export enum MOBILE_APP_REDIRECT_PARAMS {
  LOGIN_USER = 'app-login'
}
